import * as React from 'react';
import ChartLoader from '../ChartLoader';
import styles from './ChartWrapper.module.css';
const ChartWrapper = ({ ratio, loading = false, children }) => {
  const container = React.useRef<HTMLDivElement>(null);
  return (
    <div
      ref={container}
      className={styles.ChartWrapper}
      style={{ paddingTop: `${ratio * 100}%` }}
    >
      <div className={styles.ChartWrapperContent}>{children}</div>
      {loading && <ChartLoader />}
    </div>
  );
};
export default ChartWrapper;
